import PetsIcon from "@mui/icons-material/Pets";

// The site's primary navigation - the ONE list both the desktop pill and the
// mobile menu render. They used to keep separate copies, which is how the
// mobile paw lost its accessible name while the desktop one kept it.
//
// `description` is what the visitor will find on that page. It appears as the
// subtitle under each item in the mobile menu, and as each link's accessible
// description on both. It was added because labels like "Demos" do not say what
// kind of demos. Rules:
//
//   - Every claim must be true of the page as it stands. Check before editing:
//     Resume really has a PDF download, Demos really needs no sign-up.
//   - 45 characters at most (one line under a label on a phone; a test enforces it).
//   - Sentence case, no final full stop, Oxford comma - the site's own voice.
//   - No numbers that can drift ("5 demos", "13 case studies").
//
// `hideOn` lists pathnames where the item is pointless. The paw is hidden on
// the homepage because you are already there.
export const NAV_ITEMS = [
  {
    key: "home",
    label: "Home",
    to: "/",
    Icon: PetsIcon,
    hideOn: ["/"],
    description: "Featured work, skills, and what people say",
  },
  {
    key: "work",
    label: "Work",
    to: "/work",
    description: "Case studies, demos, and design systems",
  },
  {
    key: "ux-writing",
    label: "UX Writing",
    to: "/ux-writing",
    description: "Before-and-after rewrites, with the why",
  },
  {
    key: "demos",
    label: "Demos",
    to: "/live-demos",
    description: "Enterprise apps to try, no sign-up needed",
  },
  {
    key: "about",
    label: "About",
    to: "/about",
    description: "From architecture to design, words, and code",
  },
  {
    key: "resume",
    label: "Resume",
    to: "/resume",
    description: "Experience, awards, and a PDF to download",
  },
  {
    key: "contact",
    label: "Contact",
    to: "/contact",
    description: "Send a message, email, or chat on WhatsApp",
  },
];

export const isHiddenOn = (item, pathname) => Boolean(item.hideOn?.includes(pathname));

export const descriptionId = (key) => `nav-desc-${key}`;
